import { ValidationLeave as ValidationLeaveMobile } from '../../components/mobile/ValidationLeave';
import { ValidationLeave as ValidationLeaveWeb } from '../../components/web/ValidationLeave';
import withPlatformComponent from '../../components/withPlatformComponent';

const ValidationLeave = withPlatformComponent({
    web: ValidationLeaveWeb,
    mobile: ValidationLeaveMobile,
});

export default ValidationLeave;
